<template>
    <div>
        <div class="top_banner" :class="news_class[newsType]">
            <div class="top_banner_text">
                <p>{{news_type[newsType]}}</p>
                <!--<p>News</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="news_box data_hy_news">
                    <div class="search_box clearfix">
                        <input type="text" v-model="test" placeholder="请输入新闻关键词" maxlength="32">
                        <img src="@/assets/img/icon_search.png" alt="" @click="test_fun()">
                    </div>
                    <div class="news_list clearfix" v-for="(item,index) in sttusCode.list" :key="index">
                        <div class="news_list_left">
                            <img :src='item.newPicture' alt="">
                        </div>
                        <div class="news_list_right">
                            <h1 @click="fun_add(item)"

                               class="title">{{item.newsTitle}}</h1>
                            <p class="content">{{item.newAbstract}}</p>
                        </div>
                    </div>
                    <div v-if="sttusCode.list.length==0" class="nodata">
                        暂无数据
                    </div>
                </div>
                <!--分页-->
                <el-pagination
                        v-if="sttusCode.list.length>0"
                        id="guang_b"
                        :hide-on-single-page="hide_pagination"
                        background
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="pages_total"
                ></el-pagination>

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "newsHy",
        data() {
            return {
                sttusCode: [],
                hide_pagination: false,
                test: '',
                pageSize: 5,
                pageNum: 1,
                pages_total: 0,
                newsType: '',
                news_type: {
                    2: '公司新闻',
                    3: '行业动态',
                    4: '政策法规',
                    6: '合同百科',
                    7: '法律知识',
                },
                news_class: {
                    2: 'top_banner_text_2',
                    3: 'top_banner_text_3',
                    4: 'top_banner_text_4',
                    6: 'top_banner_text_6',
                    7: 'top_banner_text_7',
                }
            }
        },
        watch: {
            $route(to, from) {
                if (to.params.newsType) {
                    this.pageNum = 1
                    this.pages_total = 0
                    this.newsType = this.$route.params.newsType;
                    this.get_list();
                }
            }
        },
        created() {
            this.newsType = this.$route.params.newsType;
            this.sttusCode = []
            this.get_list();
        },
        methods: {
            fun_add(item) {
                this.$router.push({name: 'news_details', params: {newsId: item.id, newsType: item.newsType}});
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.get_list();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.get_list();
            },
            test_fun() {
                this.pageNum= 1,
                this.get_list()
            },
            get_list() {
                var params = {
                    entity: {
                        newsType: this.newsType,
                        status: 0,
                        newsTitle: this.test
                    },
                    pageBean: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }
                };
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/news/queryPage",
                    data: params,
                    succFun: res => {
                        this.sttusCode = res.data;
                        this.pages_total = res.data.total;
                    },
                    failFun: res => {

                    }
                });
            }
        }
    }
</script>

<style scoped>
    .top_banner_text_2 {
        background-image: url(~@/assets/img/banner/news_banner.png);
        background-size: 100% 100%;
    }

    .top_banner_text_3 {
        background-image: url(~@/assets/img/banner/newsHy_banner.png);
        background-size: 100% 100%;
    }

    .top_banner_text_4 {
        background-image: url(~@/assets/img/banner/head_bar_contract.png);
        background-size: 100% 100%;
    }

    .top_banner_text_6 {
        background-image: url(~@/assets/img/banner/head_bar_law.png);
        background-size: 100% 100%;
    }

    .top_banner_text_7 {
        background-image: url(~@/assets/img/banner/lawIssue_banner.png);
        background-size: 100% 100%;
    }

    .news_box {
        min-height: 400px;
    }

    .nodata {
        font-size: 18px;
        font-weight: bold;
        color: #666;
        text-align: center;
        line-height: 400px
    }
    .search_box{
        background: #ffffff;
    }
    .title{
        cursor: pointer;
    }
</style>